// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui' //element-ui的全部组件
// import 'element-ui/lib/theme-chalk/index.css' //element-ui的css
import Axios from 'axios'
import Qs from "qs"
import echarts from 'echarts';
import store from './store';
import role from './role';

Vue.use(ElementUI) //使用elementUI

import VueFullPage from 'vue-fullpage.js'; //全屏滚动
Vue.use(VueFullPage);

Vue.config.productionTip = false;

Vue.prototype.$axios = Axios;
Vue.prototype.$qs = Qs;
Vue.prototype.$echarts = echarts;
Vue.prototype.role = role;

//路由会判断用户是否登录，如果登录就直接跳转到下单页面，如果没有登录，就跳转到登录页面
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requireLogin)) { // 判断该路由是否需要登录权限
        if (sessionStorage.islogin) { // 判断当前用户的登录信息islogin是否存在
            next();
        } else {
            next({
                path: '/login'
            })
        }
    } else {
        next();
    }
});
// 引用全局变量
// var useData={
//   ExamRolePermission: {},
//   STATUS: 0,
//   api_port: "",
//   closetime: null,
//   createtime: "2022-06-02 16:30:17",
//   e_dbname: "exam_100959",
//   e_ip: "",
//   e_port: "",
//   e_using: 1,
//   edu_level: "高中",
//   exam_name: "复用项目合并测试",
//   exam_no: "100959",
//   exam_type: "0",
//   grd_name: "高一",
//   grd_no: "03",
//   is_get_knowledge_point: 1,
//   is_online_exam: 0,
//   is_queryscore: 1,
//   is_union: 1,
//   istchquerysocre: 1,
//   knowledge_amount: 0,
//   pic_constr: "OSS",
//   pic_ip: "",
//   sch_name: "五岳开发04",
//   sch_no: "WY04",
//   starttime: "06/02/2022 00:00:00",
//   sub_type: "1",
//   tch_no: "18600970000",
//   token: "17537373c1164facae45570856784d30",
//   web_port: "8080"
// }
// sessionStorage.setItem('islogin', JSON.stringify(useData))
if (sessionStorage.islogin) {
  let isloginc=JSON.parse(sessionStorage.isloginc||'{}');
  let islogin=JSON.parse(sessionStorage.islogin);

  if(isloginc.SuperAdmin==0){//教师
    islogin.tch_no=isloginc.Phone
  }else if(isloginc.SuperAdmin==1){//管理员
    islogin.tch_no=isloginc.UnitNo
  }
  sessionStorage.setItem('islogin', JSON.stringify(islogin))

    Vue.prototype.useData = islogin;
} else {
    location.href = window.location.protocol+"//" + window.location.host;
}
var apiUrl;

if(process.env.NODE_ENV == 'development'){
  apiUrl = "http://47.93.89.101:8008/";

} else {
    apiUrl = window.location.protocol +"//" + window.location.host+"/";
}
//var apiUrl="http://192.168.1.160:8008/ExamAPI/";
//axios 全局配置拦截器 每次向后端请求携带 头信息
Axios.interceptors.request.use(config => {
    var token = JSON.parse(sessionStorage.islogin).token;
    // var timestamp=role.getTimeStamp();
    // var nonce=role.getRandom();
    // var signature=role.GetSigna(config.data, token,timestamp, nonce, config.method,apiUrl);
    if (sessionStorage.islogin) {
        config.headers['token'] = token;
        // config.headers['timestamp'] = timestamp;
        // config.headers['nonce'] = nonce;
        // config.headers['signature'] = signature;
    }
    return config;
},
    err => {
        return Promise.reject(err);
    });

Vue.prototype.apiUrl = apiUrl
Axios.defaults.baseURL = apiUrl;
import './style/css/fontsize.css'
import './style/css/theme-chalk/index.css'
import './style/css/fullpage.css'
import './style/css/wuyue.css'
import './style/css/icon-font/iconfont.css'
import './style/css/sheet.css'
// import './style/css/sheet-icon-font/iconfont.css'
import './style/css/score.css'

import './style/css/common.css'
import './style/css/screen.css'
/* eslint-disable no-new */
Vue.filter('datefmt', (input, fmtstring, year, mouth, day, hours, minutes, seconds) => {
    var mydate = new Date(input);
    var y = mydate.getFullYear();
    var m = mydate.getMonth() + 1;
    var d = mydate.getDate();
    var h = mydate.getHours();
    var mi = mydate.getMinutes();
    var s = mydate.getSeconds();

    if (fmtstring == 'YYYY-MM-DD') {
        return y + year + m + mouth + d + day;
    }
    if (fmtstring == 'YYYY-MM-DD HH:mm:ss') {
        return y + year + m + mouth + d + day + h + hours + mi + minutes + s + seconds;
    }

});
new Vue({
    el: '#app',
    router,
    store,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js